export const iconSizes = {
  tiny: 16, // 16x16
  small: 20, // 20x20
  regular: 24, // 24x24
  large: 32, // 32x32
  largest: 64, // 64x64
} as const

export type IconSize = keyof typeof iconSizes

export const iconTypes = {
  ABoxed: 'ABoxed',
  ABoxedFilled: 'ABoxedFilled',
  Add: 'Add',
  AddToLibrary: 'AddToLibrary',
  Apps: 'Apps',
  ArrowBackLrg: 'ArrowBackLrg',
  ArrowDown: 'ArrowDown',
  ArrowDropDown: 'ArrowDropDown',
  ArrowDropUp: 'ArrowDropUp',
  ArrowForwardLrg: 'ArrowForwardLrg',
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight',
  ArrowUp: 'ArrowUp',
  AUnderlined: 'AUnderlined',
  BarChart: 'BarChart',
  BBoxed: 'BBoxed',
  BBoxedFilled: 'BBoxedFilled',
  Bookmark: 'Bookmark',
  BookmarkOutline: 'BookmarkOutline',
  Bookmarks: 'Bookmarks',
  BookmarksOutline: 'BookmarksOutline',
  Build: 'Build',
  BUnderlined: 'BUnderlined',
  Calendar: 'Calendar',
  Check: 'Check',
  CheckFilled: 'CheckFilled',
  CheckboxBlank: 'CheckboxBlank',
  CheckboxTicked: 'CheckboxTicked',
  CityBlock: 'CityBlock',
  Clock: 'Clock',
  Close: 'Close',
  CodeKey: 'CodeKey',
  Collapse: 'Collapse',
  ColorLens: 'ColorLens',
  Column: 'Column',
  Comment: 'Comment',
  CompareArrows: 'CompareArrows',
  Copy: 'Copy',
  Delete: 'Delete',
  DeleteOutline: 'DeleteOutline',
  Document: 'Document',
  DocumentOutline: 'DocumentOutline',
  DragIndicator: 'DragIndicator',
  Edit: 'Edit',
  Email: 'Email',
  Error: 'Error',
  Event: 'Event',
  Exit: 'Exit',
  Expand: 'Expand',
  Explore: 'Explore',
  Eye: 'Eye',
  EyeClosed: 'EyeClosed',
  FileDownload: 'FileDownload',
  Files: 'Files',
  FileUpload: 'FileUpload',
  Filter: 'Filter',
  Firm: 'Firm',
  FlagOutlined: 'FlagOutlined',
  Folder: 'Folder',
  FolderOutlined: 'FolderOutlined',
  ForkedArrow: 'ForkedArrow',
  FormatAlignCenter: 'FormatAlignCenter',
  FormatAlignLeft: 'FormatAlignLeft',
  FormatAlignRight: 'FormatAlignRight',
  FormatBold: 'FormatBold',
  FormatColorText: 'FormatColorText',
  FormatItalic: 'FormatItalic',
  FormatListBulleted: 'FormatListBulleted',
  FormatListNumbered: 'FormatListNumbered',
  FormatUnderlined: 'FormatUnderlined',
  Groups: 'Groups',
  HamburgerMenu: 'HamburgerMenu',
  Heart: 'Heart',
  HelpOutline: 'HelpOutline',
  Home: 'Home',
  Image: 'Image',
  Info: 'Info',
  InfoOutline: 'InfoOutline',
  Instituition: 'Instituition',
  KeyboardArrowDown: 'KeyboardArrowDown',
  KeyboardArrowLeft: 'KeyboardArrowLeft',
  KeyboardArrowRight: 'KeyboardArrowRight',
  KeyboardArrowUp: 'KeyboardArrowUp',
  KeyboardDoubleArrowLeft: 'KeyboardDoubleArrowLeft',
  KeyboardDoubleArrowRight: 'KeyboardDoubleArrowRight',
  IndeterminateCheckbox: 'IndeterminateCheckbox',
  Launch: 'Launch',
  Lightbulb: 'Lightbulb',
  Link: 'Link',
  LinkedIn: 'LinkedIn',
  LinkOff: 'LinkOff',
  ListAlt: 'ListAlt',
  Lock: 'Lock',
  LockOutlined: 'LockOutlined',
  Map: 'Map',
  More: 'More',
  MoreVert: 'MoreVert',
  New: 'New',
  Notifications: 'Notifications',
  Override: 'Override',
  PdfLibrary: 'PdfLibrary',
  PieChart: 'PieChart',
  Product: 'Product',
  ProductOutlined: 'ProductOutlined',
  Refresh: 'Refresh',
  Remove: 'Remove',
  RemoveCircle: 'RemoveCircle',
  Search: 'Search',
  Settings: 'Settings',
  Share: 'Share',
  Shield: 'Shield',
  ShoppingBasket: 'ShoppingBasket',
  SortByAlpha: 'SortByAlpha',
  SortByAlphaReverse: 'SortByAlphaReverse',
  SortByDate: 'SortByDate',
  SortByDateReverse: 'SortByDateReverse',
  SortHighToLow: 'SortHighToLow',
  SortLowToHigh: 'SortLowToHigh',
  SubdirectoryArrowRight: 'SubdirectoryArrowRight',
  Sync: 'Sync',
  SyncDisabled: 'SyncDisabled',
  Target: 'Target',
  Teams: 'Teams',
  TextField: 'TextField',
  ThumbUp: 'ThumbUp',
  ThumbDown: 'ThumbDown',
  ThumbUpOutlined: 'ThumbUpOutlined',
  ThumbDownOutlined: 'ThumbDownOutlined',
  User: 'User',
  Video: 'Video',
  ViewList: 'ViewList',
  Wallet: 'Wallet',
  Warning: 'Warning',
  ZoomIn: 'ZoomIn',
  ZoomOut: 'ZoomOut',
} as const

export type IconType = keyof typeof iconTypes

export default iconTypes
